// Explore sheets for phones: pure HTML string builders (no DOM), so Node tests can check them.
// Clicks are delegated through data-act like the rest of the UI (ui.js → act()). Escape anything dynamic.
import { escapeHtml } from './util.js';

const esc = (s) => escapeHtml(s ?? '');
const whole = (n) => Math.max(0, Math.floor(Number(n)) || 0);

// ☰ More: everything the phone toolbar has no room for. `friends` is how many friends are here;
// `guest` is the world owner's name while visiting a friend's world.
export function moreSheetHTML({ friends = 0, guest = '' } = {}) {
  const n = whole(friends);
  return `<div class="panel journal-panel more-panel"><h2>More</h2><p>Everything else lives here.</p>
${guest ? `<p class="more-note">🏠 You’re visiting ${esc(guest)}’s world.</p>` : ''}<div class="more-grid">
<button class="btn btn-purple more-action" data-act="expansion" data-op="quests">🐉 Quest</button>
<button class="btn btn-dark more-action" data-act="moreTown">🏡 Town</button>
<button class="btn btn-blue more-action" data-act="friendsPanel">👥 Friends${n ? ` <small>${n} here</small>` : ''}</button>
<button class="btn btn-dark more-action" data-act="exploreHelp">? How to play</button>
<button class="btn btn-dark more-action" data-act="modeHome">⌂ Home screen</button>
</div><button class="btn btn-green more-back" data-act="resume">Back to exploring</button></div>`;
}

// The guide card's full step: what to do next, a trail to follow and the controls tip.
export function guideSheetHTML(guide = {}, { dismissable = false } = {}) {
  const g = guide || {}, target = g.target;
  return `<div class="panel journal-panel guide-panel"><small>YOUR NEXT STEP</small><h2>${esc(g.title)}</h2><p>${esc(g.text)}</p>
${target?.name ? `<p class="guide-target">${esc(target.icon || '◆')} ${esc(target.name)}</p>` : ''}<div class="guide-actions">
${target ? '<button class="btn btn-green" data-act="guideTrail">Show me the way →</button>' : ''}
${dismissable ? '<button class="btn btn-dark" data-act="guideSkip">I know the controls ✓</button>' : ''}
<button class="btn btn-blue" data-act="resume">Back to exploring</button>
</div></div>`;
}
